import { render, staticRenderFns } from "./zbzx.vue?vue&type=template&id=a865b960&scoped=true&"
import script from "./zbzx.vue?vue&type=script&lang=js&"
export * from "./zbzx.vue?vue&type=script&lang=js&"
import style0 from "./zbzx.vue?vue&type=style&index=0&id=a865b960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a865b960",
  null
  
)

export default component.exports